import React from 'react';
import { render, screen } from '@testing-library/react';
import App from 'src/component/App';

test('renders knapsacklabs', () => {
  render(<App />);
  const linkElement = screen.getByText(/knapsacklabs/i);
  expect(linkElement).toBeInTheDocument();
});
